/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module PRINTER SAGA
 */

import {
  browsePrinter,
  browsePrinterDayOfUse,
  browsePrinterRecentDate,
  browsePrinterRepairByWeek,
  browsePrinterStatus,
  browsePrinterTag,
  exportPrinterReport,
  setTotal
} from "./actions";
import { call, put, select, takeLatest } from "redux-saga/effects";
import services from "services";
import _, { get } from "lodash";
import dayjs from "dayjs";
import { makeSelectInUiWithPathPrinter } from "./selectors";

// utilities
function specialSort(array, key) {
  array.sort(function(a, b) {
    // If properties are the same, compare value
    if (a === b) {
      return Object.values(a) - Object.values(b);
    }
    // Otherwise, compare keys
    return Object.keys(a) - Object.keys(b);
  });
  return array;
}

const _handleBrowsePrinterStatus = function*() {
  try {
    yield put(browsePrinterStatus.request());
    let response = yield call(services.IOT.getActivity);
    if (response && response.data) {
      let convertedData = [["Loại máy in", "Tổng số", "Không hoạt động"]];
      _.forEach(response.data, item => {
        _.forEach(item, (device, deviceId) => {
          convertedData.push([deviceId, device.total, device.stop_working]);
        });
      });
      yield put(
        browsePrinterStatus.success({
          data: convertedData
        })
      );
    } else {
      yield put(browsePrinterStatus.failure({ response }));
    }
  } catch (error) {
    yield put(browsePrinterStatus.failure({ error }));
  } finally {
    yield put(browsePrinterStatus.fulfill());
  }
};
const _handleBrowsePrinter = function*() {
  try {
    let rawParam = yield select(state =>
      makeSelectInUiWithPathPrinter(state, ["printer", "param"])
    );
    yield put(browsePrinter.request());
    let jsParam = rawParam.toJS();
    let param = {
      selectTag: jsParam.selectTag,
      station_id: jsParam.station_search,
      printer_type: jsParam.printer_type,
      printer_mac: jsParam.printer_mac,
      printer_status: jsParam.printer_status,
      param_order: jsParam.param_order,
      from: jsParam.from,
      to: jsParam.to,
      limit: jsParam.limit,
      offset: jsParam.offset
    };
    yield put(browsePrinterTag.trigger({ param: param }));
    let response = yield call(services.IOT.getList, param);
    if (response && response.data) {
      console.log(response);
      let total = _.get(response, "data.total", 0);
      yield put(
        setTotal({
          pagination: {
            total: total,
            offset: param.offset,
            limit: param.limit
          }
        })
      );
      yield put(
        browsePrinter.success({
          data: get(response, "data.data")
        })
      );
    } else {
      yield put(browsePrinter.failure({ response }));
    }
  } catch (error) {
    yield put(browsePrinter.failure({ error }));
  } finally {
    yield put(browsePrinter.fulfill());
  }
};
const _handleBrowsePrinterTag = function*(action) {
  try {
    let response = yield call(services.IOT.getPrinterTag, action.payload.param);
    if (response && response.data) {
      yield put(
        browsePrinterTag.success({
          data: _.sortBy(
            response.data,
            tag => `${tag.tag_type}-${tag.tag_name}`
          )
        })
      );
    } else {
      yield put(browsePrinterTag.failure({ response }));
    }
  } catch (error) {
    yield put(browsePrinterTag.failure({ error }));
  } finally {
    yield put(browsePrinterTag.fulfill());
  }
};
const _handleBrowsePrinterRepairByWeek = function*() {
  try {
    yield put(browsePrinterRepairByWeek.request());
    let response = yield call(services.IOT.getReportWeek);
    if (response && response.data) {
      let newData = [["Week", "Số lượng", { role: "annotation" }]];
      let dataReportConvert = specialSort(response.data);
      if (dataReportConvert) {
        dataReportConvert.forEach(item => {
          let start;
          let end;
          start = dayjs("2020")
            .add(Object.keys(item)[0], "weeks")
            .startOf("isoweek")
            .format("YYYY/MM/DD");

          end = dayjs(start)
            .add(6, "d")
            .format("DD/MM");
          start = dayjs(start).format("DD/MM");
          newData.push([
            start + " - " + end,
            Object.values(item)[0],
            Object.values(item)[0]
          ]);
          // }
        });
        yield put(browsePrinterRepairByWeek.success({ data: newData }));
      }
    } else {
      yield put(browsePrinterRepairByWeek.failure({ response }));
    }
  } catch (error) {
    yield put(browsePrinterRepairByWeek.failure({ error }));
  } finally {
    yield put(browsePrinterRepairByWeek.fulfill());
  }
};
const _handleBrowsePrinterRecentDate = function*() {
  try {
    yield put(browsePrinterRecentDate.request());
    let response = yield call(services.IOT.getPrinterTagRecentDate);
    if (response && response.data) {
      let newData = [["Tên", "Số Lượng"]];
      if (response.data) {
        _.forEach(response.data, (item, index) => {
          newData.push([item.tag_name + ": " + item.count, item.count]);
        });
      }
      yield put(
        browsePrinterRecentDate.success({
          data: newData
        })
      );
    } else {
      yield put(browsePrinterRecentDate.failure({ response }));
    }
  } catch (error) {
    yield put(browsePrinterRecentDate.failure({ error }));
  } finally {
    yield put(browsePrinterRecentDate.fulfill());
  }
};
const _handleBrowsePrinterDayOfUse = function*() {
  try {
    yield put(browsePrinterDayOfUse.request());
    let response = yield call(services.IOT.getPrinterTagNoOfUse);
    if (response && response.data) {
      let newData = [["Tên", "Số Lượng"]];
      if (response.data) {
        _.forEach(response.data, (item, index) => {
          newData.push([item.tag_name + ": " + item.count, item.count]);
        });
      }
      yield put(
        browsePrinterDayOfUse.success({
          data: newData
        })
      );
    } else {
      yield put(browsePrinterDayOfUse.failure({ response }));
    }
  } catch (error) {
    yield put(browsePrinterDayOfUse.failure({ error }));
  } finally {
    yield put(browsePrinterDayOfUse.fulfill());
  }
};
const _handleExportPrinterReport = function*() {
  try {
    yield put(exportPrinterReport.request());
    let rawParam = yield select(state =>
      makeSelectInUiWithPathPrinter(state, ["printer", "param"])
    );
    let jsParam = rawParam.toJS();
    let param = {
      staion_id: jsParam.station_search,
      printer_type: jsParam.printer_type,
      printer_mac: jsParam.printer_mac,
      printer_status: jsParam.printer_status,
      param_order: jsParam.param_order,
      from: jsParam.from,
      to: jsParam.to,
      limit: jsParam.limit,
      offset: jsParam.offset
    };
    let response = yield call(services.IOT.dowloadData, param);
    if (response && response.data) {
      if (response.data && response.data.fileName) {
        let count = 0;
        let file = `https://iot.ghtk.vn/` + response.data.fileName;
        let checkData = setInterval(() => {
          var xhr = new XMLHttpRequest();
          xhr.open("HEAD", file, false);
          xhr.send();

          if (xhr.status == "404") {
            return false;
          } else {
            if (xhr.status == "200") {
              count = count + 1;
              if (count >= 1) {
                window.open(file, "Download");
                clearInterval(checkData);
                return true;
              }
            }
            // return true;
          }
        }, 3000);
      }
      yield put(
        exportPrinterReport.success({
          data: response.data
        })
      );
    } else {
      yield put(exportPrinterReport.failure({ response }));
    }
  } catch (error) {
    yield put(exportPrinterReport.failure({ error }));
  } finally {
    yield put(exportPrinterReport.fulfill());
  }
};

export default function* saga() {
  yield takeLatest(exportPrinterReport.TRIGGER, _handleExportPrinterReport);
  yield takeLatest(browsePrinterStatus.TRIGGER, _handleBrowsePrinterStatus);
  yield takeLatest(browsePrinter.TRIGGER, _handleBrowsePrinter);
  yield takeLatest(browsePrinterTag.TRIGGER, _handleBrowsePrinterTag);
  yield takeLatest(
    browsePrinterRecentDate.TRIGGER,
    _handleBrowsePrinterRecentDate
  );
  yield takeLatest(
    browsePrinterRepairByWeek.TRIGGER,
    _handleBrowsePrinterRepairByWeek
  );
  yield takeLatest(browsePrinterDayOfUse.TRIGGER, _handleBrowsePrinterDayOfUse);
}
